import { IconButton } from '@/components/IconButton'
import { NumericSpinnerInput } from '@/components/inputs/NumericSpinnerInput'
import styles from './JobScopeInventoryItem.module.css'

export interface JobScopeInventoryItemProps {
  name: string
  description: string
  currentQuantity: number
  newQuantity: number
  onRemove: () => unknown
  onQuantityChange: (value: number | null) => unknown
  itemTestId?: string
}

export function JobScopeInventoryItem({
  name,
  description,
  currentQuantity,
  newQuantity,
  onRemove,
  onQuantityChange,
  itemTestId,
}: JobScopeInventoryItemProps) {
  return (
    <div className={styles.itemContainer} data-test="job-scope-update-item">
      <IconButton
        name="close"
        label="Remove item"
        className={styles.removeItemButton}
        onPress={onRemove}
        testId={`job-scope-update-inventory-remove-button-${itemTestId}`}
        size={24}
      />

      <div className={styles.textContainer}>
        <div className={styles.title}>{name}</div>
        <div className={styles.description}>{description}</div>
      </div>

      <div
        className={styles.currentQuantityContainer}
        data-test={`job-scope-update-inventory-current-quantity-${itemTestId}`}
      >
        {currentQuantity}
      </div>

      <NumericSpinnerInput
        min={0}
        value={newQuantity}
        onChange={onQuantityChange}
        testId={`job-scope-update-inventory-quantity-${itemTestId}`}
      />
    </div>
  )
}
